module.exports = __webpack_public_path__ + "static/img_9488-040767760a395c19e3c985e6f11f2fb8.webp";